var ip = require('ip');

/**
 * Shim for Object.assign
 * @param  {Object} target
 * @param  {Object} source
 * @return {Object}       
 */
var assign = Object.assign || function (target, source) {
    var keys = Object.keys(Object(source));
    for (var i=0; i<keys.length; i++) {
        target[keys[i]] = source[keys[i]];
    }
    return target;
};

/**
 * Returns the client IP address from request headers
 * @param  {Object} req Express request object
 * @return {String}     client IP address
 */
function getClientIP(req) {
    return req.headers['True-Client-IP'] || req.headers['x-forwarded-for'] || req.connection.remoteAddress;
}

/**
 * Checks if the IP address is private, ex: 127.0.0.1 etc
 * @param  {String}  address IP address
 * @return {Boolean}    private or public
 */
function isPrivateIP(address) {
    return ip.isPrivate(address);
}

/**
 * Returns the 3 letter month name
 * @param  {Number} monthNumber Month number
 * @return {String}             Month name
 */
function getMonthName(monthNumber) {
    var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return months[monthNumber || months[0]];
}

/**
 * Get .png mugshot of author
 * If default image url is not a png, then look for the image urls in
 * peers object. Override default image url If the image width & height
 * is 70, if image type is 1/2 and if image extension is .png.
 *
 * @param  {String} mugshot     Default image url (authors.images[0].url)
 * @param  {Object} authorImage Images object (authors.images[0])
 * @return {String}             .png url if found else mugshot
 */
function getAuthorMugshot(mugshot, authorImage) {
    if (mugshot.indexOf('.png') === -1) {
        //console.log('original mugshot is not png');
        if (authorImage.hasOwnProperty('peers')) {
            var allImages = authorImage.peers;
            for (var i = 0; i < allImages.length; i++) {
                var imgDetails = allImages[i];
                var imgDetails_type = imgDetails.type === "1" || imgDetails.type === "2";
                var imgDetails_png = false;
                // Check if url key is present and has value, then check if it's a png image
                if (imgDetails.hasOwnProperty('url') && typeof imgDetails.url === 'string') {
                    imgDetails_png = imgDetails.url.indexOf('.png') > -1;
                }
                if (imgDetails.height === 70 && imgDetails.width === 70 && imgDetails_type && imgDetails_png) {
                    mugshot = imgDetails.url;
                    //console.log('mugshot overwritten to', mugshot);
                }
            }
        }
    }
    return mugshot;
}

/**
 * Find and get the correct story image
 *
 * @param  {Object} images Images object (news.images[0])
 * @return {String/null} image url
 */
function getStoryImage(images) {
    var image = null;
    if (images.hasOwnProperty('peers')) {
        var peerImages = images.peers;
        for (var i = 0; i < peerImages.length; i++) {
            var imgDetails = peerImages[i];
            if (imgDetails.width === 900 && imgDetails.type === "4") {
                image = imgDetails.url;
            }
        }
    }
    return image;
}


/**
 * Get video object's thumbnail url.
 * For video blogs, If imageUrl is not found, Check if video thumbnail url can
 * be found.
 * @param  {Object}     Video object from feed
 * @return {String/undefined}
 */
function getVideoImageUrl(videoObj) {
    var imageUrl;
    // Return if video key is missing
    if (typeof videoObj === 'undefined') {
        return imageUrl;
    }

    // Proceed only if videoObj array is not empty
    if (videoObj.length > 0) {
        var video = videoObj[0] || {};
        if (video.hasOwnProperty('thumbnail') && typeof video.thumbnail === 'string') {
            imageUrl = 'http://a.espncdn.com/combiner/i?img=' + video.thumbnail;
        }
    }
    //console.log('getVideoImageUrl', imageUrl);
    return imageUrl;
}

/**
 * Returns the absolute image url
 * @param  {String} imgUrl 
 * @return {String}        
 */
function getImageUrl(imgUrl){
    
    var isDefaultImage = /espncdn.com\/combiner|default-team-logo-500|PICTURES\/CMS\//.test(imgUrl);
    var imgPath = '';
    
    if(!isDefaultImage){
        if(imgUrl){
            imgPath = imgUrl.split('.com')[1];
            return "http://a.espncdn.com/combiner/i?img=" + imgPath + "?w=100&amp;h=100&amp;transparent=true"; 
        }else{
            return imgPath;
        }
    }else{
        return imgUrl;
    }
}


var utils = {
    ip: {
        get: getClientIP,
        isPrivate: isPrivateIP
    },
    date: {
        getMonthName: getMonthName
    },
    blogs: {
        getStoryImage: getStoryImage,
        getAuthorMugshot: getAuthorMugshot,
        getVideoImageUrl: getVideoImageUrl
    },
    Object : {
        assign: assign
    },
    getImageUrl : getImageUrl
};

module.exports = utils;


/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/helpers/utils/index.js
 **/